import React, { useState, useEffect } from 'react';

import { useAPI } from 'api';
import { MotdResponse } from 'types';
import { useOrgContext } from 'components/OrgContextProvider';

const WorkspaceHome = () => {
	const api = useAPI();
	const ctx = useOrgContext();

	const [motd, setMotd] = useState("...");

	useEffect(() => {
		api.get<MotdResponse>(`${ctx?.apiBaseWorkspace}/settings/motd`)
		.then(json => setMotd(json.motd));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const changeMotd = () => {
		const newMotd = prompt("Enter MOTD", motd);

		if (newMotd) {
			api.post(`${ctx?.apiBaseWorkspace}/settings/motd`, { motd: newMotd })
			.then(() => setMotd(newMotd));
		}
	};

	return (
		<div>
			<h3>Workspace Home</h3>

			<p>This is the home page for workspace "{ctx?.workspace?.name}".</p>

			<p>This workspace's MOTD is "<span style={{color: '#66ffff'}} onClick={changeMotd}>{motd}</span>"</p>
		</div>
	);
};

export default WorkspaceHome;
